import angular from 'angular';

OverlayStatusDirective.$inject = ['$window', '$rootScope'];

function OverlayStatusDirective($window, $rootScope) {
  OverlayStatusController.$inject = ['$rootScope'];

  function OverlayStatusController($rootScope) {
    this.centered = false;
    this.clearNav = true;

    this.adjustPosition = function (width) {
      const self = this;
      const centered = width > 1250;
      const clearNav = width > 850;

      if (self.centered !== centered) {
        self.centered = centered;
      }
      if (self.clearNav !== clearNav) {
        self.clearNav = clearNav;
      }
    };
  }

  return {
    restrict: 'E',
    templateUrl: 'common/directives/overlayStatus/overlayStatus.tpl.html',
    controllerAs: '$ctrl',
    controller: OverlayStatusController,
    bindToController: {
      status: '@',
      onStop: '&onStop',
    },
    link: function (scope, element, attr, ctrl) {
      angular.element($window).bind('resize', function () {
        ctrl.adjustPosition($window.innerWidth);
      });
    },
  };
}

export const OverlayStatusDirectiveModule = angular
  .module('acme.common.directive.overlayStatus', [])
  .directive('overlayStatus', OverlayStatusDirective).name;
